<template>
  <div>
    <table-template ref="consumer-coupon-table-template" actionUrl="/dbtCard/findConsumerCouponInfos.action" :queryParams="queryParams">
        <template slot="search">
            <el-select v-model="queryParams.status" @change="$refs['consumer-coupon-table-template'].search()" clearable  placeholder="请选择状态">
                <el-option label="上架" :value="1"></el-option>
                <el-option label="下架" :value="2"></el-option>
            </el-select>
            <el-select v-model="queryParams.type" @change="$refs['consumer-coupon-table-template'].search()" clearable  placeholder="卡券类型">
                <el-option label="优惠券" :value="1"></el-option>
                <el-option label="福利券" :value="2"></el-option>

            </el-select>
            <el-date-picker
                    clearable
                    style="margin-left: 10px;"
                    v-model="createTimeSearch"
                    @change="onCreateTimeChanged"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="创建时间开始"
                    end-placeholder="创建时间截止">
            </el-date-picker>

            <el-input style="margin-left: 10px;width: 200px;" v-model="queryParams.keyword" placeholder="劵名称/劵内容"></el-input>
            <el-button style="margin-left: 10px;" type="primary" @click="$refs['consumer-coupon-table-template'].search()">搜索</el-button>

            <el-button type="danger" style="margin-top: 10px;" @click="$router.push('saveConsumerCoupons')">新增平台劵</el-button>
        </template>
        <template slot="item">
            <el-table-column
                    prop="name"
                    label="平台券名称">
            </el-table-column>
            <el-table-column
                    prop="purpose"
                    label="平台券内容">
            </el-table-column>
            <el-table-column
                    label="有效期">
                <template scope="scope">
                    {{scope.row.effectiveDays}} 内有效
                </template>
            </el-table-column>
            <el-table-column
                    label="卡券类型">
                <template scope="scope">
                    <span v-if="scope.row.type == 1">优惠券</span>
                    <span v-else>福利券</span>

                </template>
            </el-table-column>
            <el-table-column
                    label="适用服务类型">
                <template scope="scope">
                    {{scope.row.serviceType}}
                </template>
            </el-table-column>
            <el-table-column
                    label="状态">
                <template scope="scope">
                    <span v-bind:style="{color:getStatusColor(scope.row.status)}">{{scope.row.status | statusFilter}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="已承接商家">
                    <template scope="scope">
                        <a   @click="showBusinessCouponList(scope.row)">{{scope.row.businessCount}}</a>
                    </template>
            </el-table-column>
            <el-table-column

                    label="用户已领取">
                    <template scope="scope">
                        <a   @click="showReceivedCouponList(scope.row)">{{scope.row.userCount}}</a>
                    </template>

            </el-table-column>
            <el-table-column

                    label="用户已使用">
                    <template scope="scope">
                        <a   @click="showUedCouponList(scope.row)">{{scope.row.usedCount}}</a>
                    </template>
            </el-table-column>
            <el-table-column label="操作">
                <template scope="scope">
                    <el-button type="text" v-if="scope.row.status==1" v-confirm confirm-text="确定下架优惠券" requestUrl="dbtCard/changeConsumerCouponInfoStatus.action" :confirm-data="{id:scope.row.id,status:2}" @onConfirm="$refs['consumer-coupon-table-template'].search()">下架</el-button>
                    <el-button type="text" v-else v-confirm confirm-text="确定上架优惠券" requestUrl="dbtCard/changeConsumerCouponInfoStatus.action" :confirm-data="{id:scope.row.id,status:1}" @onConfirm="$refs['consumer-coupon-table-template'].search()" >上架</el-button>
                    <el-button type="text" @click="$router.push({name:'修改优惠券',params:{id:scope.row.id}})">编辑</el-button>
                </template>
            </el-table-column>
        </template>

    </table-template>

    <el-dialog :title="queryReceivedCouponParams.info+'的已领取用户明细'" :visible.sync="receivedCouponVisible">
        <table-template actionUrl="/dbtCard/selectReceivedCouponList.action" ref="received-coupon" :queryParams="queryReceivedCouponParams">
            <template slot="item">

                <el-table-column
                        label="负责人姓名" prop="realName">
                </el-table-column>
                <el-table-column
                        prop="phone"
                        label="联系方式">
                </el-table-column>

                <el-table-column

                        label="角色">

                        <template scope="scope">
                          {{scope.row.role | roleFilter}}
                        </template>

                </el-table-column>

                <el-table-column
                        label="领取时间">
                        <template scope="scope">
                          {{scope.row.createTime | dateTimeFormat}}
                        </template>
                </el-table-column>
                <el-table-column
                        label="状态">
                        <template scope="scope">
                            <span v-if="scope.row.isEffective == 2 ">
                                  已经过期
                            </span>
                            <span v-else>
                                {{scope.row.status |useStatusFilter}}
                            </span>

                        </template>

                </el-table-column>

            </template>
        </table-template>
    </el-dialog>

    <el-dialog :title="queryUsedCouponParams.info+'的已使用用户明细'" :visible.sync="usedCouponVisible">
        <table-template actionUrl="/dbtCard/selectReceivedCouponList.action" ref="used-coupon" :queryParams="queryUsedCouponParams">
            <template slot="item">

                <el-table-column
                        label="负责人姓名" prop="realName">
                </el-table-column>
                <el-table-column
                        prop="phone"
                        label="联系方式">
                </el-table-column>

                <el-table-column

                        label="角色">

                        <template scope="scope">
                          {{scope.row.role | roleFilter}}
                        </template>

                </el-table-column>

                <el-table-column
                        label="领取时间">
                        <template scope="scope">
                          {{scope.row.createTime | dateTimeFormat}}
                        </template>
                </el-table-column>
                <el-table-column
                        label="核销时间">
                        <template scope="scope">
                          {{scope.row.usedTime | dateTimeFormat}}
                        </template>
                </el-table-column>

                <el-table-column
                        prop="businessName"
                        label="核销门店">
                </el-table-column>

            </template>
        </table-template>
    </el-dialog>

    <el-dialog :title="queryBusinessCouponParams.info+'的已承接商家明细'" :visible.sync="businessCouponVisible">
        <table-template actionUrl="/dbtCard/selectBusinessCouponList.action" ref="card-change-record" :queryParams="queryBusinessCouponParams">
            <template slot="item">
                <el-table-column
                        prop="businessName"
                        label="商家名称">
                </el-table-column>
                <el-table-column
                        label="负责人姓名" prop="contacts">
                </el-table-column>
                <el-table-column
                        prop="phone"
                        label="联系方式">
                </el-table-column>

                <el-table-column
                        label="申请时间">
                        <template scope="scope">
                          {{scope.row.createTime | dateTimeFormat}}
                        </template>
                </el-table-column>

            </template>
        </table-template>
    </el-dialog>

    </div>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
export default {
  name: 'consumer-coupons-manager',
  data () {
    return {
      queryBusinessCouponParams: {},
      businessCouponVisible: false,

      queryUsedCouponParams: {},
      usedCouponVisible: false,

      receivedCouponVisible: false,
      queryReceivedCouponParams: {},

      createTimeSearch: null,
      queryParams: {}
    }
  },
  components: { TableTemplate },
  filters: {
    statusFilter (value) {
      let filter_value = '暂无'
      switch (value) {
        case 1:// 已上架
          filter_value = '已上架'
          break
        case 2:// 已下架
          filter_value = '已下架'
          break
      }
      return filter_value
    },
    useStatusFilter (value) {
      let filter_value = '暂无'
      switch (value) {
        case 1:// 已使用
          filter_value = '已使用'
          break
        case 2:// 待使用
          filter_value = '待使用'
          break
      }
      return filter_value
    },
    roleFilter (value) {
      let filter_value = '暂无'
      switch (value) {
        case 1:// 普通会员
          filter_value = '普通会员'
          break
        case 2:// 经纪人
          filter_value = '经纪人'
          break
        case 3:// 合伙人
          filter_value = '合伙人'
          break
      }
      return filter_value
    }
  },
  methods: {
    showBusinessCouponList (data) {
      this.queryBusinessCouponParams.consumerCouponId = data.id
      this.queryBusinessCouponParams.info = data.name
      this.businessCouponVisible = true

      this.$refs['card-change-record'].search()
    },
    showReceivedCouponList (data) {
      this.queryReceivedCouponParams.consumerCouponId = data.id
      this.queryReceivedCouponParams.info = data.name
      this.receivedCouponVisible = true
      this.$refs['received-coupon'].search()
    },
    showUedCouponList: function (data) {
      this.queryUsedCouponParams.consumerCouponId = data.id
      this.queryUsedCouponParams.info = data.name
      this.usedCouponVisible = true
      this.queryUsedCouponParams.status = 1
      this.$refs['used-coupon'].search()
    },
    onCreateTimeChanged (datetime) {
      if (!datetime || datetime[0] == null) {
        this.queryParams.createTimeSearchStart = null
        this.queryParams.createTimeSearchEnd = null
        this.$refs['consumer-coupon-table-template'].search()
        return
      }
      this.queryParams.createTimeSearchStart = datetime[0].getTime()
      this.queryParams.createTimeSearchEnd = datetime[1].getTime()
      this.$refs['consumer-coupon-table-template'].search()
    },
    getStatusColor (status) {
      let color = ''
      switch (status) {
        case 1:// 1-已上架
          color = '#00CC00'
          break
        default:// 2-已下架;
          color = '#FF0000'
      }
      return color
    }
  }
}
</script>
